(function () {
  var content = document.querySelector('.blog-post-content');
  if (!content) return;

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var idPattern = /^[a-zA-Z0-9_-]{11}$/;

  function youtubeId(src) {
    if (!src) return '';
    try {
      var url = new URL(src, window.location.origin);
      var host = url.hostname.replace(/^www\./, '');
      if (host === 'youtu.be') {
        return url.pathname.split('/').filter(Boolean)[0] || '';
      }
      if (host !== 'youtube.com' && host !== 'youtube-nocookie.com' && host !== 'm.youtube.com') {
        return '';
      }
      var parts = url.pathname.split('/').filter(Boolean);
      if (parts[0] === 'embed' || parts[0] === 'shorts' || parts[0] === 'live' || parts[0] === 'v') {
        return parts[1] || '';
      }
      return url.searchParams.get('v') || '';
    } catch (err) {
      return '';
    }
  }

  function embedSrc(id, autoplay) {
    var params = new URLSearchParams({
      autoplay: autoplay ? '1' : '0',
      mute: '1',
      playsinline: '1',
      rel: '0',
      modestbranding: '1',
      enablejsapi: '1',
      origin: window.location.origin
    });
    return 'https://www.youtube-nocookie.com/embed/' + encodeURIComponent(id) + '?' + params.toString();
  }

  function createIframe(id) {
    var iframe = document.createElement('iframe');
    iframe.src = embedSrc(id, false);
    iframe.setAttribute('allow', 'autoplay; encrypted-media; picture-in-picture');
    iframe.setAttribute('allowfullscreen', '');
    iframe.setAttribute('title', 'YouTube video');
    iframe.setAttribute('loading', 'lazy');
    return iframe;
  }

  function command(iframe, func) {
    if (!iframe.contentWindow) return;
    iframe.contentWindow.postMessage(
      JSON.stringify({ event: 'command', func: func, args: [] }),
      '*'
    );
  }

  function wrapIframe(iframe) {
    var existing = iframe.closest('.nr-video-embed');
    if (existing) return existing;

    var wrap = document.createElement('div');
    wrap.className = 'nr-video-embed';
    var parent = iframe.parentNode;
    if (
      parent &&
      parent.tagName === 'P' &&
      parent.parentNode &&
      parent.querySelectorAll('iframe').length === 1 &&
      parent.textContent.replace(/\s+/g, '') === ''
    ) {
      parent.parentNode.insertBefore(wrap, parent);
      wrap.appendChild(iframe);
      parent.remove();
    } else {
      parent.insertBefore(wrap, iframe);
      wrap.appendChild(iframe);
    }
    return wrap;
  }

  function replaceLink(link, id) {
    if (link.closest('.nr-video-embed')) return null;
    var iframe = createIframe(id);
    var wrap = document.createElement('div');
    wrap.className = 'nr-video-embed';
    var parent = link.parentNode;
    if (
      parent &&
      parent.tagName === 'P' &&
      parent.parentNode &&
      parent.querySelectorAll('a, iframe').length === 1
    ) {
      parent.parentNode.insertBefore(wrap, parent);
      wrap.appendChild(iframe);
      parent.remove();
    } else {
      parent.insertBefore(wrap, link);
      wrap.appendChild(iframe);
      link.remove();
    }
    return { wrap: wrap, iframe: iframe, id: id, loaded: false };
  }

  function markCaption(wrap) {
    var next = wrap.nextElementSibling;
    if (!next || next.tagName !== 'P') return;
    var text = (next.textContent || '').trim();
    if (!text || text.length > 140) return;
    next.classList.add('nr-video-embed__caption');
  }

  var players = [];

  content.querySelectorAll('iframe').forEach(function (iframe) {
    var id = youtubeId(iframe.getAttribute('src') || '');
    if (!idPattern.test(id)) return;
    var wrap = wrapIframe(iframe);
    wrap.setAttribute('data-nr-youtube-id', id);
    iframe.setAttribute('allow', 'autoplay; encrypted-media; picture-in-picture');
    iframe.setAttribute('allowfullscreen', '');
    iframe.setAttribute('title', iframe.getAttribute('title') || 'YouTube video');
    iframe.src = embedSrc(id, false);
    markCaption(wrap);
    players.push({ wrap: wrap, iframe: iframe, id: id, loaded: false });
  });

  content.querySelectorAll('a[href*="youtube.com"], a[href*="youtu.be"]').forEach(function (link) {
    if (link.closest('.nr-video-embed')) return;
    var id = youtubeId(link.getAttribute('href') || '');
    if (!idPattern.test(id)) return;
    var hasImage = !!link.querySelector('img');
    var parent = link.parentNode;
    var onlyChild =
      parent &&
      parent.tagName === 'P' &&
      parent.querySelectorAll('a, iframe, img').length === 1 &&
      (parent.textContent || '').trim().length < 80;
    if (!hasImage && !onlyChild) return;
    var player = replaceLink(link, id);
    if (!player) return;
    player.wrap.setAttribute('data-nr-youtube-id', id);
    markCaption(player.wrap);
    players.push(player);
  });

  if (!players.length || reduceMotion) return;

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        var player = players.find(function (item) {
          return item.wrap === entry.target;
        });
        if (!player) return;

        if (entry.isIntersecting && entry.intersectionRatio >= 0.35) {
          if (!player.loaded) {
            player.iframe.src = embedSrc(player.id, true);
            player.loaded = true;
          } else {
            command(player.iframe, 'mute');
            command(player.iframe, 'playVideo');
          }
        } else if (player.loaded) {
          command(player.iframe, 'pauseVideo');
        }
      });
    },
    { threshold: [0, 0.35, 0.6] }
  );

  players.forEach(function (player) {
    observer.observe(player.wrap);
  });
})();
